import { useState, useEffect } from "react";
import { PocketBaseClient } from "../Api/PocketbaseClient.js";
import { RecordModel } from "pocketbase";

const createUserPlaylist = async (userId: string) => {
  return PocketBaseClient.collection("user_playlists").create({
    userId,
    timestamp: new Date(),
    name: "My Playlist",
    songs: [],
  });
};

const getUserPlaylist = async (userId: string) => {
  return PocketBaseClient.collection("user_playlists").getFirstListItem(
    `userId="${userId}"`,
    {
      expand: "songs",
    }
  );
};

const getOrCreateUserPlaylist = async (userId: string) => {
  return getUserPlaylist(userId)
    .then((playlistDoc) => {
      return playlistDoc;
    })
    .catch((err) => {
      if (err.status === 404) {
        return createUserPlaylist(userId);
      }
      throw err;
    });
};

const updateUserPlaylist = (playlistId: string, songIds: string) => {
  return PocketBaseClient.collection("user_playlists").update(playlistId, {
    songs: songIds,
  });
};

export const useUserPlaylist = ({ userId }: { userId: string }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [userPlaylist, setUserPlaylist] = useState<RecordModel | null>(null);
  const [playlistSongs, setPlaylistSongs] = useState<RecordModel[]>([]);
  const [playlistId, setPlaylistId] = useState<string | null>(null);

  useEffect(() => {
    if (!userId) return;
    getOrCreateUserPlaylist(userId).then((playlistDoc) => {
      setUserPlaylist(playlistDoc);
      setPlaylistId(playlistDoc.id);
      setPlaylistSongs(playlistDoc.expand?.songs || []);
      setIsLoading(false);
    });
  }, [userId]);

  const handleUpdateUserPlaylist = (songId: string) => {
    if (!userPlaylist?.id) return Promise.reject(new Error("No playlist ID"));
    return updateUserPlaylist(userPlaylist.id, songId);
  };

  return {
    userPlaylist,
    playlistSongs,
    isLoading,
    updateUserPlaylist: handleUpdateUserPlaylist,
    playlistId,
  };
};
